import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AnswerOption, AnswerText} from '../../data/models/test/answer';

@Injectable({
  providedIn: 'root'
})
export class AnswerService {

  constructor(
    private http: HttpClient,
  ) {
  }

  addAnswerOption(testId: number, questionId: number, data: {
    text: string,
    blockedOptionIds?: number[],
  }): Promise<AnswerOption> {

    const formData = new FormData();
    formData.append('text', data.text);
    if (data.blockedOptionIds && data.blockedOptionIds.length > 0) {
      data.blockedOptionIds.forEach(id => formData.append('blockedOptionIds', id.toString()));
    }

    return this.http.post<AnswerOption>(`api/tests/${testId}/questions/${questionId}/answer-options`, formData)
      .toPromise();
  }

  updateAnswerOption(testId: number, questionId: number, optionId: number, newData: {
    text?: string,
    position?: number,
    isCorrect?: boolean,
    blockedOptionIds?: number[],
  }): Promise<AnswerOption> {

    const formData = new FormData();
    if (newData.text) {
      formData.append('text', newData.text);
    }
    if (newData.isCorrect !== undefined) {
      formData.append('isCorrect', newData.isCorrect.toString());
    }
    if (newData.position) {
      formData.append('position', newData.position.toString());
    }
    if (newData.blockedOptionIds !== undefined) {
      if (newData.blockedOptionIds.length === 0) {
        formData.append('blockedOptionIds', '');
      } else {
        newData.blockedOptionIds.forEach(id => formData.append('blockedOptionIds', id.toString()));
      }
    }

    return this.http.put<AnswerOption>(`api/tests/${testId}/questions/${questionId}/answer-options/${optionId}`, formData)
      .toPromise();
  }

  updateAnswerText(testId: number, questionId: number, newData: {
    text?: string,
  }): Promise<AnswerText> {

    const formData = new FormData();
    if (newData.text !== undefined) {
      formData.append('text', newData.text);
    }

    return this.http.put<AnswerText>(`api/tests/${testId}/questions/${questionId}/answer-text`, formData)
      .toPromise();
  }

  deleteAnswerOption(testId: number, questionId: number, optionId: number): Promise<void> {
    return this.http.delete<void>(`api/tests/${testId}/questions/${questionId}/answer-options/${optionId}`)
      .toPromise();
  }

}
